import React from "react";
import { Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const ConfirmModal = (props) => {
  const handleDelete = () => {
    Modal.confirm({
      title: props.title,
      icon: <ExclamationCircleOutlined />,
      okText: "Yes",
      cancelText: "Cancel",
      onOk: props.onOk,
    });
  };

  return (
    <span onClick={handleDelete}>
      {props.btnName}
    </span>
  );
};

{/* <ConfirmModal
  title="Are you sure?"
  btnType="danger"
  btnName="Delete"
  onOk={() => {
    props.deleteDepartment(item._id);
  }}
/>; */}

export default ConfirmModal;
